module.exports = __webpack_public_path__ + "static/media/btnLoading.77e7c260.gif";